import { useTranslation } from "react-i18next";
import { Moon, Sun } from "lucide-react";
import { Button } from "./ui/button";
import { useTheme } from "./ThemeProvider";

// Single top-bar toggle: flips between light and dark based on what's
// currently painted. (The "system" preference is still the initial default;
// an explicit click pins light or dark.)
export function ThemeSwitcher() {
  const { t } = useTranslation();
  const { resolved, setTheme } = useTheme();
  const next = resolved === "dark" ? "light" : "dark";

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      aria-label={t("theme.toggleTo", { mode: t(`theme.${next}`) })}
      title={t("theme.toggleTo", { mode: t(`theme.${next}`) })}
      onClick={() => setTheme(next)}
    >
      {resolved === "dark" ? (
        <Sun className="h-5 w-5" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
    </Button>
  );
}
